import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import BottomSheet from "../BottomSheet";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LogoutModal from "./LogoutModal";
import { getUserValidationResult, logoutUser } from "../../services/auth";

const items = [
  {
    title: "",
    img: "",
  },
  {},
];

export default function ContentItems({ name, setItemActive, state }) {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [activate, setActivate] = useState(false);
  const [active, setActive] = useState(state ? "ruls" : "info");
  const [hasExInfoFilled, setExInfoFilled] = useState(true);
  const [supportActivate, setSupportActivate] = useState(false);

  const navigate = useNavigate();
  function handleClick(event) {
    setActive(event.target.name);
    setItemActive(event.target.name);
  }
  useEffect(() => {
    getUserValidationResult().then(({ data }) => {
      if (data?.data) {
        const keys = Object.keys(data.data);
        for (let key of keys) {
          if (!data.data[key]) {
            setExInfoFilled(false);
          }
        }
      }
    });
  }, []);
  const handleTel = () => {
    window.open("tel:02191692419");
  };
  const e2p = (s) => s.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  const actionButtons = () => {
    return (
      <div className="logout-bottom-row-buttons">
        <button
          className="form-input-button-custom not-active-login"
          onClick={() => {
            logoutUser().then((data) => {
              if (data.status === 200 || data.status === 201) {
                window.localStorage.removeItem("token");
                window.localStorage.removeItem("refresh");
                navigate("/");
                toast.success("با موفقیت خارج شدید!");
              }
            });
          }}
        >
          خروج از حساب کاربری
        </button>
        <button
          className="form-input-button-custom"
          onClick={() => setActivate(false)}
        >
          بازگشت به طلایی شو
        </button>
      </div>
    );
  };
  function Openchanger(res) {
    setActivate(res);
  }
  return (
    <>
      {isTabletOrMobile ? (
        <>
          <div className="css-all-content content-of-menu-items">
            <div className="account-user-info-row">
              <img
                className="css-5334-ico account-user-info-img"
                src="/images/svg/account-user-info.svg"
                alt="accounting"
                name={"info"}
              />
              <div className="account-info-first-name">
                {name.indexOf("undefined") >= 0 || name.indexOf("null") >= 0
                  ? "-"
                  : name}
              </div>
            </div>
            <button
              name={"info"}
              className={`css-item516871 d-flex  ${
                active == "info" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-my-info.svg"
                alt="accounting"
                name={"info"}
              />
              مشخصات من
            </button>
            <button
              name={"auth"}
              className={`css-item516871 d-flex  ${
                active == "auth" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-focus.svg"
                alt="accounting"
                name={"auth"}
              />
              احرازهویت
              {!hasExInfoFilled && (
                <div className="info-not-filled">
                  <img src={"/images/svg/warning-red.svg"} /> نیازمند ویرایش یا
                  تکمیل
                </div>
              )}
            </button>
            <button
              name="history"
              className={`css-item516871 d-flex  ${
                active == "history" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-history.svg"
                alt="accounting"
                name="history"
              />
              تاریخچه معاملات
            </button>
            <button
              name={"menu"}
              className={`account-support-container css-item516871 d-flex  ${
                active == "support" ? "css-item516871-active" : ""
              }`}
              onClick={() => setSupportActivate(true)}
            >
              <img
                className="css-5334-ico account-support-image"
                src="./images/svg/account-support.svg"
                alt="accounting"
                name={"menu"}
              />
              پشتیبانی
            </button>
            <button
              name="ref"
              className={`css-item516871 d-flex  ${
                active == "ref" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico account-info-invitation-image"
                src="./images/svg/account-invitation.svg"
                alt="accounting"
                name="ref"
              />
              دعوت
            </button>
            <button
              name="card-management"
              className={`css-item516871 d-flex  ${
                active == "card-management" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/credit-card.svg"
                alt="accounting"
                name="card-management"
              />
              مدیریت کارت های بانکی
            </button>

            <button
              name="comm"
              className={`css-item516871 d-flex ${
                active == "comm" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-info-terms.svg"
                alt="accounting"
                name="comm"
              />
              پیشنهاد، انتقاد و شکایت
            </button>

            <button
              name="ruls"
              className={`css-item516871 d-flex  ${
                active == "ruls" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-info-rules.svg"
                alt="accounting"
                name="ruls"
              />
              قوانین و مقررات
            </button>
            <button
              name="channels"
              className={`css-item516871 d-flex  ${
                active == "channels" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-info-film.svg"
                alt="channels"
                name="channels"
              />
              فیلم
            </button>
            <button
              name="aichat"
              className={`css-item516871 d-flex  ${
                active == "aichat" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <span className="icon-for-ai">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 60 60"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-labelledby="title"
                >
                  <title>Outlined Robot Icon</title>

                  <rect
                    x="12"
                    y="20"
                    width="36"
                    height="30"
                    rx="6"
                    fill="none"
                    stroke="#be7530ff"
                    stroke-width="4"
                  />

                  <rect
                    x="18"
                    y="6"
                    width="24"
                    height="16"
                    rx="4"
                    fill="none"
                    stroke="#be7530ff"
                    stroke-width="4"
                  />

                  <circle cx="24" cy="14" r="2" fill="#be7530ff" />
                  <circle cx="36" cy="14" r="2" fill="#be7530ff" />

                  <line
                    x1="26"
                    y1="28"
                    x2="34"
                    y2="28"
                    stroke="#be7530ff"
                    stroke-width="4"
                    stroke-linecap="round"
                  />

                  <line
                    x1="24"
                    y1="6"
                    x2="24"
                    y2="2"
                    stroke="#be7530ff"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                  <line
                    x1="36"
                    y1="6"
                    x2="36"
                    y2="2"
                    stroke="#be7530ff"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                  <circle cx="24" cy="2" r="2" fill="#be7530ff" />
                  <circle cx="36" cy="2" r="2" fill="#be7530ff" />
                </svg>
              </span>
              هوش مصنوعی
            </button>
            <button
              name="logout"
              className={`css-item516871 d-flex ${
                active == "logout" ? "css-item516871-active" : ""
              }`}
              onClick={() => setActivate(true)}
            >
              <img
                name="logout"
                className="css-5334-ico"
                src="./images/svg/account-info-sign-out.svg"
                alt="accounting"
              />
              خروج از سیستم
            </button>
          </div>
        </>
      ) : (
        <div className="side-menu-wrapper-desktop">
          <div className="content-of-menu-items">
            <div className="account-user-info-row">
              <img
                className="css-5334-ico account-user-info-img"
                src="/images/svg/account-user-info.svg"
                alt="accounting"
                name={"info"}
              />
              <div className="account-info-first-name">
                {name.indexOf("undefined") >= 0 ? "-" : name}
              </div>
            </div>
            <button
              name={"info"}
              className={`d-flex  ${
                active == "info" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-my-info.svg"
                alt="accounting"
                name={"info"}
              />
              مشخصات من
            </button>
            <button
              name={"auth"}
              className={`d-flex  ${
                active == "auth" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-focus.svg"
                alt="accounting"
                name={"auth"}
              />
              احرازهویت
              {!hasExInfoFilled && (
                <div className="info-not-filled">
                  <img src={"/images/svg/warning-red.svg"} /> نیازمند ویرایش یا
                  تکمیل
                </div>
              )}
            </button>
            <button
              name="history"
              className={`d-flex  ${
                active == "history" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-history.svg"
                alt="accounting"
                name="history"
              />
              تاریخچه معاملات
            </button>
            <button
              name={"menu"}
              className={`account-support-container d-flex  ${
                active == "support" ? "css-item516871-active" : ""
              }`}
              onClick={() => setSupportActivate(true)}
            >
              <img
                className="css-5334-ico account-support-image"
                src="./images/svg/account-support.svg"
                alt="accounting"
                name={"menu"}
              />
              پشتیبانی
            </button>
            <button
              name="ref"
              className={`d-flex  ${
                active == "ref" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico account-info-invitation-image"
                src="./images/svg/account-invitation.svg"
                alt="accounting"
                name="ref"
              />
              دعوت
            </button>
            <button
              name="card-management"
              className={`d-flex  ${
                active == "card-management" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico account-info-invitation-image account-card-management"
                src="./images/svg/credit-card.svg"
                alt="card-management"
                name="card-management"
              />
              مدیریت کارت های بانکی
            </button>
            <button
              name="ruls"
              className={`d-flex  ${
                active == "ruls" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-info-rules.svg"
                alt="accounting"
                name="ruls"
              />
              قوانین و مقررات
            </button>
            <button
              name="channels"
              className={`d-flex  ${
                active == "film" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-info-film.svg"
                alt="channels"
                name="channels"
              />
              فیلم
            </button>
            <button
              name="aichat"
              className={`d-flex  ${
                active == "aichat" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <span className="icon-for-ai">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 60 60"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-labelledby="title"
                >
                  <title>Outlined Robot Icon</title>

                  <rect
                    x="12"
                    y="20"
                    width="36"
                    height="30"
                    rx="6"
                    fill="none"
                    stroke="#be7530ff"
                    stroke-width="4"
                  />

                  <rect
                    x="18"
                    y="6"
                    width="24"
                    height="16"
                    rx="4"
                    fill="none"
                    stroke="#be7530ff"
                    stroke-width="4"
                  />

                  <circle cx="24" cy="14" r="2" fill="#be7530ff" />
                  <circle cx="36" cy="14" r="2" fill="#be7530ff" />

                  <line
                    x1="26"
                    y1="28"
                    x2="34"
                    y2="28"
                    stroke="#be7530ff"
                    stroke-width="4"
                    stroke-linecap="round"
                  />

                  <line
                    x1="24"
                    y1="6"
                    x2="24"
                    y2="2"
                    stroke="#be7530ff"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                  <line
                    x1="36"
                    y1="6"
                    x2="36"
                    y2="2"
                    stroke="#be7530ff"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                  <circle cx="24" cy="2" r="2" fill="#be7530ff" />
                  <circle cx="36" cy="2" r="2" fill="#be7530ff" />
                </svg>
              </span>
              هوش مصنوعی
            </button>
            <button
              name="comm"
              className={`d-flex ${
                active == "comm" ? "css-item516871-active" : ""
              }`}
              onClick={handleClick}
            >
              <img
                className="css-5334-ico"
                src="./images/svg/account-info-terms.svg"
                alt="accounting"
                name="comm"
              />
              پیشنهاد، انتقاد و شکایت
            </button>
            <button
              name="logout"
              className={`d-flex ${
                active == "logout" ? "css-item516871-active" : ""
              }`}
              onClick={() => {
                setActivate(true);
              }}
            >
              <img
                name="logout"
                className="css-5334-ico"
                src="./images/svg/account-info-sign-out.svg"
                alt="accounting"
              />
              خروج از سیستم
            </button>
          </div>
        </div>
      )}
      {isTabletOrMobile ? (
        <BottomSheet
          onClose={() => setActivate(false)}
          activate={activate}
          actionButtons={actionButtons}
        >
          <div className="logout-small-text">خروج از حساب کاربری</div>
          <div className="logout-red-note-text">
            از حساب کاربری‌ خارج می‌شوید؟
          </div>
        </BottomSheet>
      ) : (
        <LogoutModal modalIsOpen={activate} Openchanger={Openchanger} />
      )}

      <div className="support-bottom-sheet">
        <BottomSheet
          onClose={() => setSupportActivate(false)}
          activate={supportActivate}
          actionButtons={() => <></>}
        >
          <div className="margin-bottom-btn-support">
            <button
              onClick={handleTel}
              className="form-input-button-custom not-active-login"
            >
              تماس با پشتیبانی
            </button>
          </div>
          <div>
            <button
              onClick={() => {
                window.open(
                  "https://www.goftino.com/c/64CIdJ",
                  "GoftinoChat",
                  "width=600,height=700,scrollbars=yes,resizable=yes"
                );
              }}
              className="form-input-button-custom not-active-login"
            >
              چت آنلاین
            </button>
          </div>
        </BottomSheet>
      </div>
    </>
  );
}
